import { Injectable } from '@angular/core';

import { IPriceCore as IBasePrice, IPrice } from '@frontend/oxygen/shared-utils';

import { SportsLegPriceModel } from './sports-leg-price';

@Injectable({ providedIn: 'root' })
export class SportsLegPriceService {
    constructor() {}

    construct(data: IBasePrice): SportsLegPriceModel {
        return new SportsLegPriceModel(data);
    }

    parse(someDoc: IBasePrice) {
        return new SportsLegPriceModel({
            priceNum: someDoc.priceNum || 0,
            priceDen: someDoc.priceDen || 0,
            priceType: <string>someDoc?.priceTypeRef?.id,
        });
    }

    convert(obj: IPrice): IBasePrice {
        return (
            obj && {
                priceNum: obj.num,
                priceDen: obj.den,
                priceType: obj.type,
            }
        );
    }
}
